const initialState = {
    refDataEventsByGroup: [],
    refDataEventsByGroupSingle: [],
};
export default initialState;